import { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';
import safeLocalStorage from 'common/support/safeLocalStorage';

export const useUUID = (key: string): string => {
  const uuid = useMemo(() => getUUID(key), [key]);

  return uuid;
};

export const getUUID = (key: string): string => {
  const storedUUID = safeLocalStorage.getItem(key);
  if (storedUUID) {
    return storedUUID;
  }

  const newUuid = uuidv4();
  safeLocalStorage.setItem(key, newUuid);
  return newUuid;
};
